var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnLeftAero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24532 1.14281e-05C5.39435 -0.000817163 5.54026 0.0408041 5.66446 0.119568C5.78865 0.198333 5.88549 0.310671 5.94264 0.442262C5.99979 0.573853 6.01466 0.718733 5.98534 0.858433C5.95603 0.998132 5.88386 1.12632 5.77804 1.22665L1.80136 5.02136L5.77804 8.81607C5.90097 8.9533 5.9652 9.12981 5.9579 9.31035C5.95061 9.49089 5.87233 9.66214 5.7387 9.7899C5.60507 9.91765 5.42594 9.99249 5.23711 9.99947C5.04827 10.0064 4.86363 9.94503 4.7201 9.82751L0.218187 5.5235C0.0784392 5.3891 -2.3286e-07 5.20729 -2.3286e-07 5.01778C-2.3286e-07 4.82827 0.0784392 4.64646 0.218187 4.51205L4.7201 0.208039C4.85985 0.0755159 5.04848 0.000803813 5.24532 1.14281e-05Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24626 1.22674e-05C9.39511 -0.000812559 9.54084 0.0406195 9.66487 0.119026C9.78891 0.197432 9.88564 0.30926 9.94271 0.440253C9.99979 0.571246 10.0146 0.715468 9.98536 0.854533C9.95608 0.993598 9.88401 1.1212 9.77832 1.22108L5.8066 4.99855L9.77832 8.77601C9.91943 8.91047 9.99871 9.09284 9.99871 9.283C9.99871 9.47316 9.91943 9.65553 9.77832 9.79C9.63721 9.92446 9.44582 10 9.24626 10C9.0467 10 8.85531 9.92446 8.7142 9.79L4.21791 5.50554C4.07834 5.37175 4 5.19076 4 5.00212C4 4.81347 4.07834 4.63248 4.21791 4.49869L8.7142 0.214235C8.7836 0.146763 8.86637 0.0930868 8.9577 0.0563143C9.04903 0.0195418 9.14711 0.000404474 9.24626 1.22674e-05Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLeftAero);
export default __webpack_public_path__ + "static/media/btn-left-aero.f921303ef073939b03b267f0a1f8dff5.svg";
export { ForwardRef as ReactComponent };